import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { BixiLabelComponent } from './label.component';
import { BixiLabelTooltipComponent } from './label-tooltip.component';

@NgModule({
  imports: [CommonModule, NzIconModule, DragDropModule, OverlayModule, NzToolTipModule, NzPopoverModule],
  declarations: [BixiLabelComponent, BixiLabelTooltipComponent],
  exports: [BixiLabelComponent]
})
export class BixiLabelModule { }
